
define('text!templates/widgets/account/item.ejs',[],function () { return '<a href="<%= pageUrl(id, {roles: [\'normal\']}) || \'javascript:void(0);\' %>" title="<%= i18n.t(\'account.\' + id) %>" data-toggle="tooltip">\n    <span><%= name %></span>\n    <i><%= money(value) %> <small><%= currency %></small></i>\n</a>\n';});

